import { useCallback } from 'react';
import { useThrottledCallback } from 'use-debounce';

import { useDocumentActions } from '../../../../store';

export const useHandlers = () => {
  const documentActions = useDocumentActions();

  const handleDetailsClick = useCallback(
    (variation) => {
      documentActions.openVariationDetailsPanel(variation.instanceId);
    },
    [documentActions]
  );

  const handleScoreHover = useThrottledCallback((variation) => {
    documentActions.activateVariation(variation.instanceId);
  }, 100);

  return {
    handleDetailsClick,
    handleScoreHover,
  };
};
